import { render, staticRenderFns } from "./ForoCategoria.vue?vue&type=template&id=e15471ca&scoped=true"
import script from "./ForoCategoria.vue?vue&type=script&lang=js"
export * from "./ForoCategoria.vue?vue&type=script&lang=js"
import style0 from "./ForoCategoria.vue?vue&type=style&index=0&id=e15471ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e15471ca",
  null
  
)

export default component.exports